import cn from 'clsx';

import { ZoomIn, ZoomOut } from './Icons';
import styles from './MapControls.css';
import { FC } from 'react';

interface IMapControlsProps {
  zoomIn(): void;
  zoomOut(): void;
}

export const RegionalDistrictsMapControls: FC<IMapControlsProps> = ({ zoomIn, zoomOut }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['map-controls']}>
        <button className={cn(styles['button'], styles['zoom-in'])} onClick={zoomIn}>
          <ZoomIn />
        </button>
        <button className={cn(styles['button'], styles['zoom-out'])} onClick={zoomOut}>
          <ZoomOut />
        </button>
      </div>
    </div>
  );
};
